import React from "react";
import FixedTopicHeader from "./FixedTopicHeader";
import TopicHeader from "./TopicHeader";
import { useStore } from "../../store";
import useAudio from "../../hooks/useAudio";

// <audio> is added here so the sound continues playing while transitioning between TopicHeader and FixedHeader during scroll.
const ContentHeader = (props) => {
  const { isHeaderFixed, title, testId } = props;
  const [audioRef, togglePlay, handleOnEnded] = useAudio();
  const { baseMediaUrls, contributorLogos } = useStore();

  // get pronunciation audio if available
  const url = baseMediaUrls?.audio
    ? `${baseMediaUrls?.audio}${title.pronunciationAudio}`
    : "";
  const hasAudio = title.pronunciationAudio && url;

  return (
    <div data-testid={testId} id="content-header">
      {hasAudio && (
        <audio
          ref={audioRef}
          src={url}
          data-testid="audioPlayer"
          preload="metadata"
          onEnded={handleOnEnded}
        />
      )}

      {isHeaderFixed && <FixedTopicHeader {...props} />}
      <TopicHeader
        togglePlay={togglePlay}
        hasAudio={hasAudio}
        contributorLogos={contributorLogos}
        {...props}
      />
    </div>
  );
};

ContentHeader.displayName = "ContentHeader";

export default ContentHeader;
